import React, { useRef } from 'react';
import CustomModal from '../../../components/common/CustomDialog/CustomModal';
import OtpVerificationForm from './OtpVerificationForm';

const OtpVerificationModal = ({
  open,
  otpType,
  mobileNumber,
  emailAddress,
  onClose,
  onSubmit,
  onResend,
}) => {
  const formikRef = useRef(null);

  return (
    <CustomModal
      open={open}
      title="Verification Code"
      cancelLabel="Cancel"
      submitLabel="Verify"
      onCancel={onClose}
      onSubmit={() => formikRef.current?.submitForm()}
      width="400px"
      disable={formikRef.current?.isSubmitting}
    >
      <OtpVerificationForm
        mobileNumber={otpType === 'mobile' ? mobileNumber : emailAddress}
        onSubmit={onSubmit}
        onResend={onResend}
        showSubText
        showButton={false}
        formikRef={formikRef}
      />
    </CustomModal>
  );
};

export default OtpVerificationModal;